export default {
  bindings: {},
  controller: [
    '$uibModal',
    'domainInfo',
    function($modal, domainInfo) {
      this.domainInfo = domainInfo

      this.openOpStats = () => {
        $modal.open({
          template: `<div class="modal-header">
          <a class="close" ng-click="$close()">&times;</a>
          <h4 class="modal-title">Refresh Op Metadata</h4>
        </div>
        <div class="modal-body">
        <pre>${JSON.stringify(domainInfo.usersCacheUI.opMetadata, null, 2)}</pre>
        </div>`
        })
      }
    }
  ],
  template: `
    <div style="display: inline-block; vertical-align: middle; position: relative">
      <button class="btn btn-default navbar-btn navbar-left" ng-disabled="$ctrl.domainInfo.usersCacheUI.refreshing" ng-click="$ctrl.domainInfo.refreshUserCache({})">
        Refresh users
      </button>
      <p class="navbar-text navbar-left text-muted" ng-show="$ctrl.domainInfo.usersCacheUI.status">
        <i class="fa fa-spinner fa-spin"></i> <i>{{ $ctrl.domainInfo.usersCacheUI.status }}</i>
      </p>
      <button ng-show="!$ctrl.domainInfo.usersCacheUI.status" class="btn navbar-btn navbar-left btn-link btn-sm" ng-if="$ctrl.domainInfo.usersCacheUI.opMetadata" ng-click="$ctrl.openOpStats()">View refresh stats</button>
    </div>`
}
